import { AgreementCopyContentModel, OrgUserModel, OrgUserSearchResult, UserId } from '@cibo/core'
import { descend, path } from 'ramda'
import {
  AgreementAllowedAction,
  AgreementAttachmentFile,
  AgreementDeclinedItems,
  AgreementShape,
  AgreementStatus,
  AgreementType,
} from '../types'

export class AgreementModel
  implements Omit<AgreementShape, 'createdDate' | 'modifiedDate' | 'publicationDateTime'> {
  allowedActions: AgreementAllowedAction[]
  agreementId: string
  createdDate: Date
  modifiedDate: Date
  agreementType: AgreementType
  name: string

  docPath: string
  docRevision: number
  fileName: string
  status: AgreementStatus
  userId: UserId
  user: OrgUserSearchResult
  resourceIds?: string[]
  declined?: AgreementDeclinedItems[]
  offerGroup?: string | undefined
  agreementCopy?: AgreementCopyContentModel
  publicationDateTime?: Date

  files: AgreementAttachmentFile[]

  userModel: OrgUserModel

  constructor(params: any) {
    this.userId = params?.userId
    this.agreementId = params?.agreementId
    this.agreementType = params?.agreementType
    this.allowedActions = params?.allowedActions
    this.name = params?.name
    this.status = params?.status
    this.createdDate = new Date(params?.createdDate)
    this.modifiedDate = new Date(params?.modifiedDate)
    this.docPath = params?.docPath
    this.docRevision = params?.docRevision
    this.fileName = params?.fileName
    this.files = params?.files.sort(descend(path(['fileData', 'modifiedDate'])))
    this.user = params?.user
    this.resourceIds = params?.resourceIds
    this.declined = params?.declined
    this.offerGroup = params?.offerGroup
    this.userModel = new OrgUserModel(params?.user)
    this.publicationDateTime = new Date(params?.publicationDateTime)
  }

  isAllowed(action: AgreementAllowedAction) {
    return this.allowedActions?.includes(action)
  }

  setAgreementCopy = (copy?: AgreementCopyContentModel) => (this.agreementCopy = copy)
}
